import { createFileRoute } from '@tanstack/react-router'
import { Guides } from '@/views/guides/Guides'

export const Route = createFileRoute('/_authenticated/guides')({
    component: Guides,
})
